import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const Product = ({ scale = 1, modelPath = "/models/scene.glb", sizeMultiplier = 1 }) => {
  const { scene } = useGLTF(modelPath);
  const groupRef = useRef();
  const rad = 22 * Math.PI / 180;
  return (
    <group ref={groupRef} dispose={null} scale={scale * sizeMultiplier} rotation={[0, rad, 0]}>
      {scene && <primitive object={scene} />}
    </group>
  );
};

export default Product;

// 预加载模型
useGLTF.preload("/models/scene.glb");
